import React, { useState } from 'react';
import { HEIGHT_FOOT } from '../Config';
import Grilla from './Grilla';

import PoliticaPrivacidadPopup from '../PoliticaPrivacidadPopup';
import { Link } from 'react-router-dom';


interface FooterProps {
    codigoDivipola : string;
    filtrar: any; // Replace 'any' with the appropriate type for filters
    onToggleDetalles: (id: any) => void;
}

const Footer: React.FC<FooterProps> = ({ codigoDivipola, filtrar, onToggleDetalles }) => {
    const [showPrivacy, setShowPrivacy] = useState(false);
    return (
        <footer style={{ height: "400px", backgroundColor: "#f8f9fa", position: 'relative' }}>
            <Grilla codigoDivipola={codigoDivipola} filtrar={filtrar} onToggleDetalles={onToggleDetalles} />
            <div style={{ position: 'absolute', bottom: 10, right: 20, display: 'flex', gap: 16 }}>
                <button
                    style={{ background: 'none', border: 'none', color: '#007bff', textDecoration: 'underline', cursor: 'pointer', fontSize: 14 }}
                    onClick={() => setShowPrivacy(true)}
                >
                                    </button>
                <Link
                    to="/privacy"
                    style={{ color: '#007bff', textDecoration: 'underline', fontSize: 14 }}
                >
                </Link>
            </div>
            {showPrivacy && (
                <PoliticaPrivacidadPopup onClose={() => setShowPrivacy(false)} />
            )}
        </footer>
    );
};

export default Footer;